import { __extends } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { selectors } from '../../../../Stream';
import { withTranslation } from 'react-i18next';
import LoadingIndicator from '../../../../LoadingIndicator';
import { getBrowseDeviationStreamId } from '../../../helpers';
import DeviationSelector from '../';
import SearchInput from '../../../_partials/SearchInput';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import { getDeviationsByIds } from '../../../../redux/deviations/selectors';
import withSearch from '../../../_hocs/withSearch';
import NoSearchResults from '../../../_partials/NoSearchResults';
import { fetchMoreBrowseDeviations } from '../../../actions';
import { getSearchQuery } from '../../../selectors';
import { withMobileContext } from '../../../../Context';
var enhance = compose(connectMediaStore(function (state) {
    var streamId = getBrowseDeviationStreamId(getSearchQuery(state));
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        isFetching: selectors.isFetching(state, streamId),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId),
    };
}, { fetchMoreBrowseDeviations: fetchMoreBrowseDeviations }), withSearch, withMobileContext, withTranslation());
var BrowseDeviationSelector = /** @class */ (function (_super) {
    __extends(BrowseDeviationSelector, _super);
    function BrowseDeviationSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchMoreIfNeeded = function () {
            var _a = _this.props, hasMore = _a.hasMore, isFetching = _a.isFetching;
            if (!hasMore || isFetching) {
                return;
            }
            _this.props.fetchMoreBrowseDeviations();
        };
        _this.renderContent = function () {
            var _a = _this.props, isInitialized = _a.isInitialized, isFetching = _a.isFetching, deviations = _a.deviations, searchQuery = _a.searchQuery, hasMore = _a.hasMore;
            if (searchQuery && !deviations.length && isInitialized && !isFetching) {
                return React.createElement(NoSearchResults, null);
            }
            return (React.createElement(React.Fragment, null,
                isInitialized && deviations.length > 0 && (React.createElement(DeviationSelector, { deviations: deviations })),
                (!isInitialized || isFetching) && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !hasMore }))));
        };
        return _this;
    }
    BrowseDeviationSelector.prototype.render = function () {
        return (React.createElement(PopupInnerLayout, { headerExtrasBottomZone: React.createElement(SelectedItemsPanel, null), headerExtrasRightZone: React.createElement(SearchInput, null), scrollableContent: this.renderContent(), onScrolledToBottom: this.fetchMoreIfNeeded, onNotScrollable: this.fetchMoreIfNeeded }));
    };
    return BrowseDeviationSelector;
}(React.Component));
export { BrowseDeviationSelector };
export default enhance(BrowseDeviationSelector);
//# sourceMappingURL=BrowseDeviationSelector.connected.js.map